export const STATIC_LIST = 1
export const DYNAMIC_LIST = 2
export const DYNAMIC_REMOTE_LIST = 3
